import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchCustomerGroups(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { encodeValuesOnly: true }
  );
  const { data } = await api.get(`/customer-groups/detailed?${query}`);
  return data;
}

export function useCustomerGroupsQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["customers", "groups", filters, page, pageSize],
    queryFn: () => fetchCustomerGroups(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useCreateCustomerGroupMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/customer-groups`, payload);
      return data;
    }
  });
}

export function useSaveCustomerGroupMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.put(`/customer-groups/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteCustomerGroupMutation() {
  return useMutation({
    mutationFn: async (id) => {
      await api.delete(`/customer-groups/${id}`);
      return true;
    }
  });
}

